import style from "./style.module.scss";

export default function VideoPart() {
    return <div className={style.videoPart}>
        <video src="/Videos/Siesta Homes.mp4" autoPlay muted loop />
        <div className={style.desc}>
            Gevonden?<br />
            Wacht niet tot<br />
            het weg is!<br />
            Bezoek nu uw<br />
            droom en kom<br />
            snel naar<br />
            Spanje
        </div>
    </div>
}